import type { UserVoiceNpsProps } from "./components/UserVoiceNps";
import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, LazyModule, LazyAction, LazyImport, type LazyComponent, } from "owa-bundling";

export { Team1 } from "./services/UserVoiceFeedbackTags";
export type { UserVoiceFeedbackTags, UserVoiceFeedbackTxpTags, } from "./services/UserVoiceFeedbackTags";
export type { SuggestionDialogOptions } from "./actions/showUserVoiceSuggestionDialog";
export { FeedbackMaxCharsAllowed } from "./utils/UserVoiceConstantsForExport";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "UserVoice" */ "./lazyIndex"), {
    name: "UserVoice",
});

export const lazyLaunchInAppFeedback: LazyAction<typeof lazyIndex.launchInAppFeedback, typeof lazyModule> = new LazyAction(lazyModule, m => m.launchInAppFeedback);
export const lazyPostSuggestionAndSendLogDatapoint: LazyImport<typeof lazyIndex.postSuggestionAndSendLogDatapoint, typeof lazyModule> = new LazyImport(lazyModule, m => m.postSuggestionAndSendLogDatapoint);
export const lazyShowUserVoiceSuggestionDialog: LazyImport<typeof lazyIndex.showUserVoiceSuggestionDialog, typeof lazyModule> = new LazyImport(lazyModule, m => m.showUserVoiceSuggestionDialog);
export const UserVoiceNps: LazyComponent<UserVoiceNpsProps, unknown, void> = createLazyComponent(lazyModule, m => m.UserVoiceNps);

export const lazyUserVoiceSuggestionStore: LazyImport<typeof lazyIndex.userVoiceSuggestionStore, typeof lazyModule> = new LazyImport(lazyModule, m => m.userVoiceSuggestionStore);
